import list from '@/pages/address/list'
import add from '@/pages/address/add'
import edit from '@/pages/address/edit'

const routes = [
  {
    path:'/Address/List',
    component:list,
    meta:{requiredAuth:true}
  },
  {
    path:'/Address/add',
    component:add,
    meta:{requiredAuth:true}
  },
  {
    path:'/Address/edit/:id',
    component:edit,
    meta:{requiredAuth:true}
  }
]

export default routes;